module.exports = __webpack_public_path__ + "static/media/Yifan-IV16.246a65b0.png";